module.exports = "img/background.f49ea1117fb1e40635e7736935759fa8.jpg";